import { Injectable, ViewChild } from '@angular/core';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { Utils } from 'src/utils';
import { SchematicsService } from './schematics.service';
import { Subscription } from 'rxjs';
import { RadiatorSchematicComponent } from '../components/radiator-schematic/radiator-schematic.component';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
@Injectable({
  providedIn: 'root'
})
export class PdfService {
  pdfMake: any;
  currentProperty;
  currentSnapshot;
  schematic
  dataURL
  @ViewChild(RadiatorSchematicComponent, { static: false }) radiatorSchematic;

  constructor(private schematicsService: SchematicsService) {
  }
  async loadPdfMaker() {
    if (!this.pdfMake) {
      const pdfMakeModule = await import("pdfmake/build/pdfmake");
      const pdfFontsModule = await import("pdfmake/build/vfs_fonts");
      this.pdfMake = pdfMakeModule.default;
      this.pdfMake.vfs = pdfFontsModule.default.pdfMake.vfs;
      this.pdfMake.title = 'test'
    }

  }


  // getSchematic(snapshot) {
  //   this.schematicsService.getSchematic(snapshot.veId, snapshot.heatingSystem.veDocId).then(resp => {
  //     console.log(resp)
  //     this.schematic = resp
  //   })
  // }

  async generatePdf(snapshot, imageURL?) {
    console.log(snapshot)
    // this.getSchematic(snapshot)
    await this.loadPdfMaker();
    const def = this.createPdf(snapshot, imageURL)
    this.pdfMake.createPdf(def).open();
  }


  createPdf(snapshot, imageURL?) {
    var dd = {
      info: {
        title: `${snapshot.address.firstLine}, ${snapshot.address.postcode} -  ${snapshot.assessmentPeriodStart} to ${snapshot.assessmentPeriodEnd}  `,
        author: 'Glowmarkt'

      },
      content: [




        { text: `Assessment Period: ${Utils.getReadableDateFromIso(snapshot.assessmentPeriodStart)} to ${Utils.getReadableDateFromIso(snapshot.assessmentPeriodEnd)}`, style: 'heading6' },
        { svg: '<svg width="520px" height="1px" viewBox="0 0 520 1" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Page-1" stroke="none" stroke-width="0.75" fill="none" fill-rule="evenodd" stroke-opacity="0.85"><line x1="0" y1="0" x2="520" y2="0" id="Path" stroke="#D1D1D1"></line></g></svg>', margin: [0, 0, 0, 20] },
        //row 1 
        {
          columnGap: 10,
          columns: [
            {
              //   background: '#2b2b2b',
              width: 200,
              type: 'none',
              ul:
                [

                  { text: 'Address:', style: { bold: true } },
                  { text: `${snapshot.address.firstLine}`, style: "text" },
                  // { text: `${this.currentProperty.region}`, style: "text" },
                  { text: `${snapshot.address.postcode}`, style: "text" }],
            },
            {
              width: 250,
              layout: 'noBorders',
              fillColor: '#F0FDFF',
              table: {
                widths: [200, 100],
                body: [
                  [{ text: 'Preferred installation timeframe: ', style: 'tableHeader' }, { text: snapshot.overview.installationDate, style: 'tableData', alignment: 'right' }],
                  [{ text: 'Space for hot water tank:', style: 'tableHeader' }, { text: `${snapshot.overview.hotWaterTankSpace == true ? 'Yes' : 'No'}`, style: 'tableData', alignment: 'right' }],
                  [{ text: 'New radiators installed:', style: 'tableHeader' }, { text: `${snapshot.overview.newRadiatorsFitted == true ? 'Yes' : 'No'}`, style: 'tableData', alignment: 'right' }],
                ]
              }
            },

          ]
        },


        //epc section
        snapshot.epc ? { text: 'EPC information', style: 'sectionHeading' } : '',

        snapshot.epc ? {
          columnGap: 5,
          columns: [
            //epc SCALE
            {
              table: {
                widths: [51, 3, 3, 3, 3, 3, 3, 3, 1, 35, 40],
                color: '#ffffff',
                body: [
                  [
                    {
                      colSpan: 9,
                      border: [true, true, true, false],
                      fillColor: '#ffffff',
                      text: '',
                      color: '#ffffff',
                    },
                    // keep empty {}
                    {},
                    {},
                    {},
                    {},
                    {},
                    {},
                    {},
                    {},

                    {
                      border: [false, true, false, true],
                      fillColor: '#ffffff',
                      text: 'Current',
                      color: '',
                      fontSize: 10
                    },
                    {
                      border: [true, true, true, true],
                      fillColor: '#ffffff',
                      text: 'Potential',
                      color: '',
                      fontSize: 10
                    },



                  ],
                  [
                    {
                      border: [true, false, false, false],
                      fillColor: '#01803D',
                      text: '(92 +) A',
                      color: '#ffffff',
                      bold: true

                    },
                    {

                      border: [false, false, false, false],
                      fillColor: '#01803D',
                      text: '',
                      color: '#ffffff',

                    },
                    {
                      border: [false, false, false, false],
                      fillColor: '#ffffff',
                      text: '',

                    },
                    {
                      border: [false, false, false, false],
                      fillColor: '#ffffff',
                      text: ''

                    },
                    {
                      border: [false, false, false, false],
                      fillColor: '#ffffff',
                      text: ''


                    },
                    {
                      border: [false, false, false, false],
                      fillColor: '#ffffff',
                      text: ''


                    },
                    {
                      border: [false, false, false, false],
                      fillColor: '#ffffff',
                      text: ''


                    },
                    {
                      border: [false, false, false, false],
                      fillColor: '#ffffff',
                      text: ''


                    },
                    {
                      border: [false, false, false, false],
                      fillColor: '#ffffff',
                      text: ''


                    },
                    {
                      border: [true, false, false, false],
                      fillColor: snapshot.epc.currentEnergyEfficiencyScore >= 92 ? '#01803D' : '#ffffff',
                      text: snapshot.epc.currentEnergyEfficiencyScore >= 92 ? `${snapshot.epc.currentEnergyEfficiencyScore}` : '',
                      color: '#ffffff',
                      bold: true


                    },
                    {
                      border: [true, false, true, false],
                      fillColor: snapshot.epc.potentialEnergyEfficiencyScore >= 92 ? '#01803D' : '#ffffff',
                      text: snapshot.epc.potentialEnergyEfficiencyScore >= 92 ? `${snapshot.epc.potentialEnergyEfficiencyScore}` : '',
                      color: '#ffffff',
                      bold: true



                    },


                  ],
                  [
                    {
                      border: [true, false, false, false],
                      fillColor: '#2C9F28',
                      text: '(81-91) B',
                      color: '#ffffff',
                      bold: true
                    },
                    {

                      border: [false, false, false, false],
                      fillColor: '#2C9F28',
                      text: '',
                      color: '#ffffff',

                    },
                    {
                      border: [false, false, false, false],
                      fillColor: '#2C9F28',
                      text: '',

                    },
                    {
                      border: [false, false, false, false],
                      fillColor: '#ffffff',
                      text: ''

                    },
                    {
                      border: [false, false, false, false],
                      fillColor: '#ffffff',
                      text: ''


                    },
                    {
                      border: [false, false, false, false],
                      fillColor: '#ffffff',
                      text: ''


                    },
                    {
                      border: [false, false, false, false],
                      fillColor: '#ffffff',
                      text: ''


                    },
                    {
                      border: [false, false, false, false],
                      fillColor: '#ffffff',
                      text: ''


                    },
                    {
                      border: [false, false, false, false],
                      fillColor: '#ffffff',
                      text: ''


                    },
                    {
                      border: [true, false, true, false],
                      fillColor: snapshot.epc.currentEnergyEfficiencyScore >= 81 && snapshot.epc.currentEnergyEfficiencyScore < 91 ? '#2C9F28' : '#ffffff',
                      text: snapshot.epc.currentEnergyEfficiencyScore >= 81 && snapshot.epc.currentEnergyEfficiencyScore < 91 ? `${snapshot.epc.currentEnergyEfficiencyScore}` : '',
                      color: '#ffffff',
                      bold: true


                    },
                    {
                      border: [true, false, true, false],
                      fillColor: snapshot.epc.potentialEnergyEfficiencyScore >= 81 && snapshot.epc.potentialEnergyEfficiencyScore <= 91 ? '#2C9F28' : '#ffffff',
                      text: snapshot.epc.potentialEnergyEfficiencyScore >= 81 && snapshot.epc.potentialEnergyEfficiencyScore <= 91 ? `${snapshot.epc.potentialEnergyEfficiencyScore}` : '',
                      color: '#ffffff',
                      bold: true


                    },


                  ],
                  [
                    {
                      border: [true, false, false, false],
                      fillColor: '#9ECB3D',
                      text: '(69-80) C',
                      color: '#ffffff',
                      bold: true
                    },
                    {

                      border: [false, false, false, false],
                      fillColor: '#9ECB3D',
                      text: '',
                      color: '#ffffff',

                    },
                    {
                      border: [false, false, false, false],
                      fillColor: '#9ECB3D',
                      text: '',

                    },
                    {
                      border: [false, false, false, false],
                      fillColor: '#9ECB3D',
                      text: ''

                    },
                    {
                      border: [false, false, false, false],
                      fillColor: '#ffffff',
                      text: ''


                    },
                    {
                      border: [false, false, false, false],
                      fillColor: '#ffffff',
                      text: ''


                    },
                    {
                      border: [false, false, false, false],
                      fillColor: '#ffffff',
                      text: ''


                    },
                    {
                      border: [false, false, false, false],
                      fillColor: '#ffffff',
                      text: ''


                    },
                    {
                      border: [false, false, false, false],
                      fillColor: '#ffffff',
                      text: ''


                    },
                    {
                      border: [true, false, false, false],
                      fillColor: snapshot.epc.currentEnergyEfficiencyScore >= 69 && snapshot.epc.currentEnergyEfficiencyScore <= 80 ? '#9ECB3D' : '#ffffff',
                      text: snapshot.epc.currentEnergyEfficiencyScore >= 69 && snapshot.epc.currentEnergyEfficiencyScore <= 80 ? `${snapshot.epc.currentEnergyEfficiencyScore}` : '',
                      color: '#ffffff',
                      bold: true


                    },
                    {
                      border: [true, false, true, false],
                      fillColor: snapshot.epc.potentialEnergyEfficiencyScore >= 69 && snapshot.epc.potentialEnergyEfficiencyScore <= 80 ? '#9ECB3D' : '#ffffff',
                      text: snapshot.epc.potentialEnergyEfficiencyScore >= 69 && snapshot.epc.potentialEnergyEfficiencyScore <= 80 ? `${snapshot.epc.potentialEnergyEfficiencyScore}` : '',
                      color: '#ffffff',
                      bold: true


                    },


                  ],
                  [
                    {
                      border: [true, false, false, false],
                      fillColor: '#FEF200',
                      text: '(55-68) D',
                      color: '#2b2b2b',
                      bold: true
                    },
                    {

                      border: [false, false, false, false],
                      fillColor: '#FEF200',
                      text: '',
                      color: '#ffffff',

                    },
                    {
                      border: [false, false, false, false],
                      fillColor: '#FEF200',
                      text: '',

                    },
                    {
                      border: [false, false, false, false],
                      fillColor: '#FEF200',
                      text: ''

                    },
                    {
                      border: [false, false, false, false],
                      fillColor: '#FEF200',
                      text: ''


                    },
                    {
                      border: [false, false, false, false],
                      fillColor: '#ffffff',
                      text: ''


                    },
                    {
                      border: [false, false, false, false],
                      fillColor: '#ffffff',
                      text: ''


                    },
                    {
                      border: [false, false, false, false],
                      fillColor: '#ffffff',
                      text: ''


                    },
                    {
                      border: [false, false, false, false],
                      fillColor: '#ffffff',
                      text: ''


                    },
                    {
                      border: [true, false, false, false],
                      fillColor: snapshot.epc.currentEnergyEfficiencyScore >= 55 && snapshot.epc.currentEnergyEfficiencyScore <= 68 ? '#FEF200' : '#ffffff',
                      text: snapshot.epc.currentEnergyEfficiencyScore >= 55 && snapshot.epc.currentEnergyEfficiencyScore <= 68 ? `${snapshot.epc.currentEnergyEfficiencyScore}` : '',
                      color: '#2B2B2B',
                      bold: true


                    },
                    {
                      border: [true, false, true, false],
                      fillColor: snapshot.epc.potentialEnergyEfficiencyScore >= 55 && snapshot.epc.potentialEnergyEfficiencyScore <= 68 ? '#FEF200' : '#ffffff',
                      text: snapshot.epc.potentialEnergyEfficiencyScore >= 55 && snapshot.epc.potentialEnergyEfficiencyScore <= 68 ? `${snapshot.epc.potentialEnergyEfficiencyScore}` : '',
                      color: '#2B2B2B',
                      bold: true


                    },


                  ],
                  [
                    {
                      border: [true, false, false, false],
                      fillColor: '#F7AF1D',
                      text: '(39-54) E',
                      color: '#ffffff',
                      bold: true
                    },
                    {

                      border: [false, false, false, false],
                      fillColor: '#F7AF1D',
                      text: '',
                      color: '#ffffff',

                    },
                    {
                      border: [false, false, false, false],
                      fillColor: '#F7AF1D',
                      text: '',

                    },
                    {
                      border: [false, false, false, false],
                      fillColor: '#F7AF1D',
                      text: ''

                    },
                    {
                      border: [false, false, false, false],
                      fillColor: '#F7AF1D',
                      text: ''


                    },
                    {
                      border: [false, false, false, false],
                      fillColor: '#F7AF1D',
                      text: ''


                    },
                    {
                      border: [false, false, false, false],
                      fillColor: '#ffffff',
                      text: ''


                    },
                    {
                      border: [false, false, false, false],
                      fillColor: '#ffffff',
                      text: ''


                    },
                    {
                      border: [false, false, false, false],
                      fillColor: '#ffffff',
                      text: ''


                    },
                    {
                      border: [true, false, false, false],
                      fillColor: snapshot.epc.currentEnergyEfficiencyScore >= 39 && snapshot.epc.currentEnergyEfficiencyScore <= 54 ? '#F7AF1D' : '#ffffff',
                      text: snapshot.epc.currentEnergyEfficiencyScore >= 39 && snapshot.epc.currentEnergyEfficiencyScore <= 54 ? `${snapshot.epc.currentEnergyEfficiencyScore}` : '',
                      color: '#ffffff',
                      bold: true


                    },
                    {
                      border: [true, false, true, false],
                      fillColor: snapshot.epc.potentialEnergyEfficiencyScore >= 39 && snapshot.epc.potentialEnergyEfficiencyScore <= 54 ? '#F7AF1D' : '#ffffff',
                      text: snapshot.epc.potentialEnergyEfficiencyScore >= 39 && snapshot.epc.potentialEnergyEfficiencyScore <= 54 ? `${snapshot.epc.potentialEnergyEfficiencyScore}` : '',
                      color: '#ffffff',
                      bold: true


                    },


                  ],
                  [
                    {
                      border: [true, false, false, false],
                      fillColor: '#ED6924',
                      text: '(21-38) F',
                      color: '#ffffff',
                      bold: true
                    },
                    {

                      border: [false, false, false, false],
                      fillColor: '#ED6924',
                      text: '',
                      color: '#ffffff',

                    },
                    {
                      border: [false, false, false, false],
                      fillColor: '#ED6924',
                      text: '',

                    },
                    {
                      border: [false, false, false, false],
                      fillColor: '#ED6924',
                      text: ''

                    },
                    {
                      border: [false, false, false, false],
                      fillColor: '#ED6924',
                      text: ''


                    },
                    {
                      border: [false, false, false, false],
                      fillColor: '#ED6924',
                      text: ''


                    },
                    {
                      border: [false, false, false, false],
                      fillColor: '#ED6924',
                      text: ''


                    },
                    {
                      border: [false, false, false, false],
                      fillColor: '#ffffff',
                      text: ''


                    },
                    {
                      border: [false, false, false, false],
                      fillColor: '#ffffff',
                      text: ''


                    },
                    {
                      border: [true, false, false, false],
                      fillColor: snapshot.epc.currentEnergyEfficiencyScore >= 21 && snapshot.epc.currentEnergyEfficiencyScore <= 38 ? '#ED6924' : '#ffffff',
                      text: snapshot.epc.currentEnergyEfficiencyScore >= 21 && snapshot.epc.currentEnergyEfficiencyScore <= 38 ? `${snapshot.epc.currentEnergyEfficiencyScore}` : '',
                      color: '#ffffff',
                      bold: true


                    },
                    {
                      border: [true, false, true, false],
                      fillColor: snapshot.epc.potentialEnergyEfficiencyScore >= 21 && snapshot.epc.potentialEnergyEfficiencyScore <= 38 ? '#ED6924' : '#ffffff',
                      text: snapshot.epc.potentialEnergyEfficiencyScore >= 21 && snapshot.epc.potentialEnergyEfficiencyScore <= 38 ? `${snapshot.epc.potentialEnergyEfficiencyScore}` : '',
                      color: '#ffffff',
                      bold: true


                    },


                  ],
                  [
                    {
                      border: [true, false, false, true],
                      fillColor: '#E41D24',
                      text: '(1-20) G',
                      color: '#ffffff',
                      bold: true
                    },
                    {

                      border: [false, false, false, true],
                      fillColor: '#E41D24',
                      text: '',
                      color: '#ffffff',

                    },
                    {
                      border: [false, false, false, true],
                      fillColor: '#E41D24',
                      text: '',

                    },
                    {
                      border: [false, false, false, true],
                      fillColor: '#E41D24',
                      text: ''

                    },
                    {
                      border: [false, false, false, true],
                      fillColor: '#E41D24',
                      text: ''


                    },
                    {
                      border: [false, false, false, true],
                      fillColor: '#E41D24',
                      text: ''


                    },
                    {
                      border: [false, false, false, true],
                      fillColor: '#E41D24',
                      text: ''


                    },
                    {
                      border: [false, false, false, true],
                      fillColor: '#E41D24',
                      text: ''


                    },
                    {
                      border: [false, false, false, true],
                      fillColor: '#ffffff',
                      text: ''


                    },
                    {
                      border: [true, false, false, true],
                      fillColor: snapshot.epc.currentEnergyEfficiencyScore <= 20 ? '#E41D24' : '#ffffff',
                      text: snapshot.epc.currentEnergyEfficiencyScore <= 20 ? `${snapshot.epc.currentEnergyEfficiencyScore}` : '',
                      color: '#ffffff',
                      bold: true


                    },
                    {
                      border: [true, false, true, true],
                      fillColor: snapshot.epc.potentialEnergyEfficiencyScore <= 20 ? '#E41D24' : '#ffffff',
                      text: snapshot.epc.potentialEnergyEfficiencyScore <= 20 ? `${snapshot.epc.potentialEnergyEfficiencyScore}` : '',
                      color: '#ffffff',
                      bold: true


                    },


                  ],
                ]
              },

            },

            {
              layout: 'noBorders',
              fillColor: '#F0FDFF',
              table: {
                body: [
                  [{ text: 'Current energy rating:', style: 'tableHeader' }, { text: `${snapshot.epc.currentEnergyRating}`, style: 'tableData', alignment: 'right' }],
                  [{ text: 'Potential energy rating:', style: 'tableHeader' }, { text: `${snapshot.epc.potentialEnergyRating}`, style: 'tableData', alignment: 'right' }],
                  [{ text: 'Lodgement date:', style: 'tableHeader' }, { text: `${snapshot.epc.lodgementDate}`, style: 'tableData', alignment: 'right' }],
                  [{ text: 'Building type:', style: 'tableHeader' }, { text: `${snapshot.epc.buildingType}`, style: 'tableData', alignment: 'right' }],
                  [{ text: 'Windows type:', style: 'tableHeader' }, { text: `${snapshot.epc.windowType}`, style: 'tableData', alignment: 'right' }],
                  [{ text: 'Build date', style: 'tableHeader' }, { text: `${snapshot.epc.buildDate}`, style: 'tableData', alignment: 'right' }],

                ]
              }
            },

          ]
        } : '',
        //Thermal performance section

        snapshot.thermalPerformance.htc || snapshot.thermalPerformance.hlp ? { text: 'Thermal Performance¹', style: 'sectionHeading' } :'',

        snapshot.thermalPerformance.htc || snapshot.thermalPerformance.hlp?{
          columnGap: 40,
          columns: [
            {
              layout: 'noBorders',
              fillColor: '#FFFFFF',

              table: {
                widths: [160, 80],
                body: [
                  [{ text: 'Building fabric score (HTC Score):', style: 'tableHeader', background: '' }, { text: `${snapshot.thermalPerformance.htc} W/K`, style: 'tableData', alignment: 'right' }],
                  [{ text: 'Heat loss parameter (HLP)', style: 'tableHeader' }, { text: `${snapshot.thermalPerformance.hlp} W/m²/K`, style: 'tableData', alignment: 'right' }],
                ]
              }
            },
            {

              // HLP table
              table: {
                widths: [30, 50, 10, 10, 10, 20],
                color: '#ffffff',
                body: [
                  [
                    {
                      colSpan: 5,
                      border: [true, true, true, true],
                      fillColor: '#FFFFFF',
                      text: '',
                      color: '#ffffff',
                    },
                    {},
                    {},
                    {},
                    {},

                    {
                      border: [true, true, true, true],
                      fillColor: '#ffffff',
                      text: `HLP`,
                      color: '#2B2B2B',
                      fontSize: 10,
                      bold: true
                    },


                  ],
                  [
                    {
                      border: [true, false, false, false],
                      fillColor: '#65A36A',
                      text: '0-1',
                      color: '#ffffff',
                    },
                    {

                      border: [false, false, false, false],
                      fillColor: '#2F652D',
                      text: 'Excellent',
                      color: '#ffffff',

                    },
                    {
                      border: [false, false, false, false],
                      fillColor: '#ffffff',
                      text: '',

                    },
                    {
                      border: [false, false, false, false],
                      fillColor: '#ffffff',
                      text: '',

                    },
                    {
                      border: [false, false, false, false],
                      fillColor: '#ffffff',
                      text: '',

                    },

                    {
                      border: [true, false, true, false],
                      fillColor: '#ffffff',
                      text: snapshot.thermalPerformance.hlp <= 1 ? `${snapshot.thermalPerformance.hlp}` : '',
                      color: '#2F652D',
                      bold: true
                    },


                  ],
                  [
                    {
                      border: [true, false, false, false],
                      fillColor: '#B7D87E',
                      text: '1-2',
                      color: '#ffffff',
                    },
                    {
                      border: [false, false, false, false],
                      fillColor: '#8EC141',
                      text: 'Good',
                      color: '#ffffff',

                    },
                    {
                      border: [false, false, false, false],
                      fillColor: '#8EC141',
                      text: ''
                    },

                    {
                      border: [false, false, false, false],
                      fillColor: '#ffffff',
                      text: ''

                    },

                    {
                      border: [false, false, false, false],
                      fillColor: '#ffffff',
                      text: ''
                    },
                    {
                      border: [true, false, true, false],
                      fillColor: '#ffffff',
                      text: snapshot.thermalPerformance.hlp > 1 && snapshot.thermalPerformance.hlp <= 2 ? `${snapshot.thermalPerformance.hlp}` : '',
                      color: '#8EC141',
                      bold: true
                    },


                  ],
                  [
                    {
                      border: [true, false, false, false],
                      fillColor: '#F2D767',
                      text: '2-3',
                      color: '#ffffff',
                    },
                    {
                      border: [false, false, false, false],
                      fillColor: '#F7CE46',
                      text: 'Average',
                      color: '#ffffff',

                    },
                    {
                      border: [false, false, false, false],
                      fillColor: '#F7CE46',
                      text: ''
                    },

                    {
                      border: [false, false, false, false],
                      fillColor: '#F7CE46',
                      text: ''

                    },

                    {
                      border: [false, false, true, false],
                      fillColor: '#ffffff',
                      text: ''
                    },
                    {
                      border: [true, false, true, false],
                      fillColor: '#ffffff',
                      text: snapshot.thermalPerformance.hlp > 2 && snapshot.thermalPerformance.hlp <= 3 ? `${snapshot.thermalPerformance.hlp}` : '',
                      color: '#F7CE46',
                      bold: true,
                    },


                  ],
                  [
                    {
                      border: [true, false, false, true],
                      fillColor: '#E75F5A',
                      text: '3+',
                      color: '#ffffff',
                    },
                    {
                      border: [false, false, false, true],
                      fillColor: '#EA3323',
                      text: 'Poor',
                      color: '#ffffff',

                    },
                    {
                      border: [false, false, false, true],
                      fillColor: '#EA3323',
                      text: ''
                    },

                    {
                      border: [false, false, false, true],
                      fillColor: '#EA3323',
                      text: ''

                    },

                    {
                      border: [false, false, false, true],
                      fillColor: '#EA3323',
                      text: ''
                    },

                    {
                      border: [true, false, true, true],
                      fillColor: '#ffffff',
                      text: snapshot.thermalPerformance.hlp > 3 ? `${snapshot.thermalPerformance.hlp}` : '',
                      color: '#EA3323',
                      bold: true,
                    },


                  ]



                ]
              },
            },




          ]
        } :'',

        { text: 'Actual current energy consumption- from smart meters', style: 'sectionHeading' },


        {
          columns: [
            {
              layout: 'noBorders',
              fillColor: '#F0FDFF',
              table: {
                widths: [350, 70],
                body: [
                  [{ text: 'Annual electricity consumption:', style: 'tableHeader', background: '' }, { text: `${snapshot.energyConsumption.annualElectricityConsumption} kWh`, style: 'tableData', alignment: 'right' }],
                  [{ text: 'Annual gas consumption', style: 'tableHeader' }, { text: `${snapshot.energyConsumption.annualGasConsumption} kWh`, style: 'tableData', alignment: 'right' }],
                  [snapshot.energyConsumption.peakDemand.length ? { text: `Gas peak demand on  the coldest day² - temperature: ${snapshot.energyConsumption.peakDemand.temperature}°C`, style: 'tableHeader' } : '', snapshot.energyConsumption.peakDemand.length ? { text: `${snapshot.energyConsumption.peakDemand.consumption} kWh`, style: 'tableData', alignment: 'right' } : ''],

                ]
              }
            },


          ]
          
        },
        {
          margin: [0, 5, 5, 30],
          height: 40,
          width: 120,
          image: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAWkAAABvCAYAAAAuVTHnAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAABrNSURBVHgB7Z1rrBVVlsfXed73Ay42goIPWnz1Y0SxnYRp1EkYJxOVTmQmgklnBiNIdzrG53zRaPPFOH4gnen4iE4mGSVxNBnUD9KY+DaxUXGmnUFktLmgXFTgAvd17nl3/Qv37WLfveu5q04dXL+kcu49p07VrjpV/71q7bXWzjQajSYxDMMwaWQ4SwzDMExqYZFmGIZJMSzSDMMwKYZFmmEYJsWwSDMMw6QYFmmGYZgUk6c2oVmdoub0EWqMH7Bfsdjvf/sKMp3zrCPqpmzXPMr0LqastWQK3RSWZqlMUzt3U3Xk8Mx7xSVnU/eVlxDDMEwSZNIcJ10/tocax60FrxDn2hQFBUKdnXMR5c5YRjnr1S+Tb31EE9vfo4Yl1DK5uf009Iub7FeGYZgYGU6dSEOY64d3Uf3QO6FE2Q1Y2hDs4nmrKWNZ2zrGf/eeLdBuZLs6aN7d61ioGYaJk/SINMS5tm+b/ZoEuQUrlGJdHx2jbzb/m69tFM46wxZqhmGYmBhuuU8avubq8DaqHdhBSQJLvWQtsljDivZL9eBhqnz2JRW/fzYxDMPEQUtFuma5Naq7nzLu1ggCxHrast4Li1dRftEqW3SDULMs7yIxDMPEQ0tEulXWsw5EiFT2bqXqF+9S/Xiv9U6BGIZh0kDiIt0sHaHpXQ+fEjqXFhrHDhBVytYI46WW07rH13fgw2YYhomLRJNZEEaXVoGeoTJOjdE3LBfMcWIYhmk1iYk0BLqcdoEW1CepOfo6CzXDMC0nEZGeEegWDhAGplFloWYYpuXELtLwQZf/8Ju2EehmzZFh+K1Qw7JmGIZpBbGLdJw+6Ey+284itGt2xIUl1PBRU7NKDMMwSRNrdEfl/7caFWiIMWpwoB5Hbu5Fs8S5MXHADu9DWnnTcrHUjxvKXrQs6cbYf1N2YDkxDMMkSWwibad5G4iDhrWMJBO7SJJHgSSINxDroYOojbxDNdQBidpZlPZRszBAme6lxDAMkxSxiXRl91MUBSHO+cWr7L9DbcOytAvnr7YXCHX1j9siiXVz4v8o03WetWFOdmEYJhliEemolitqQXf++FdGfc35BStsCxuZhXCHhAL+aUuos31/QQzDMEkQy8AhLNawwHru+smvYxkMxDY7fvQrKpy3WrtObtBjv5N7OdqDYZjEMC7SUaxouCWKS9dS3NguEI1Q1w+PeH3dsqZ3E8MwTBIYF+mwVjQsaDcL1zRuQu2JNYjIIXkMwySBUZFGREcYK1oM8CUN9pkd9D+llpMm3B4MwzAxY1akLVdHGDov/+fQERxR6bj01lD7bk6xSDMMEz/GLemgYGaUWDMGPcC+4WoJDFLGK4eJYRgmToyJtD2bdwhXR7EFbg6Z0LHYlW+IYRgmTsyJdIgUbKR4t9KKFojEmaCwJc0wTNwYS2Zxujoa002a3Fuj8tcNynZmqGtxjrrOyc3eueXqSAuwpiufvDjr/UYjT9VKkRr1HOXyVcoXapTN1k5+CEuaozwYhokRYyLdKJ10dRx7u0zHd1ZtoRYcw44GsjRvVQf1LD25S1ivsKTTAtqTtWt+7LP/L09320utMnua2WJXibp7xk+KdX2CGIZh4sKYu6M5cYBGnpmi0bcqpwi0oHaiQV89X6IT71dO7rhvMaWN/IK/sl9Lk300OTaoFGhQKXXR2LEhajSz7PJgGCZWjIg0Bg2PvjpNpf11z3WP7CjbbpDcvPRY0YLsnAupXs/bIu0F3B8TJ+baUR4MwzBxYUSkq0cnbReHXyDomRRa0mBifND3urC0a9UiMQzDxIURkYYrIwiwuJuZIUojzXou0PrVSgcxDMPEhZGBw9roGAVF5bdmzDE+Pk7vv/++/Qr6+vpo4cKFdNFF4dLgkwLtfe2112b+b5d2M0xcxDp9VjuS68hRfdrbt55WDh48SM8++yy9+OKLMwLtBKJ37bXX0saNG+mss87yu1lb8B9//PFZ769bt87eXlTQ1kceecRutwq0e/ny5XTNNdfQjTfeSH644447Zp0DCP7mzZuV66NzeP3112lkZGRmn1u2bFGuqzsf2Db2IfPpp5/ax+cE5//qq68OdP5wPI899hhNTEzYv7XAra1eqM7TFVdcQbfffjsFBb/fSy+9pP1cnBu8ig4Yvyv+NrEft+sRvyt+M+d5A7gX0AaZ9evXkwmi3iNGRLrr4iWB1s8WOymTS2f/kO203B0nqC3BhQshUImzAJ9hPSwQO79ijQv8gw8+mPX+DTfcQFGBON5///2e7cZ6WCBSTz/9tGe7cTNCHJ2oBFSAm95pxYv9qgQE5wJC7USIjq798vnD/9hfkBsY+0QnLON2XG7g/KBjksHvHUak8T35vHiB84ZrEfvzK9a66/GWW27RfgfXjSzsopNQEfQ4dES9R4z4pHOW6BZ6B3yv3zlnPlX3fUVpo1mqULGzFug7HZ1TlAb8CJ0MhBpWVCvBjaCy5NzADQorx+s7KheJsJJVyBaW2/qq98O4ZIRbyi8qQY2CSugAji/IbxIF7OeZZ56hNWvWKH+DIPT29irfx/GoLO8wHVHSmBHpuf3Us3AJZX1Yx/muHuqev5hqB9MXX1y12lQsTFBhoNPX+l1IaMm13jWCCxsCHQZYUrAwWkXYduOm8/quzrpUCSyEQra6wZ49e3xvI+gjuyCI8OpENSxuHYTpfXnht/MNg+oax/Vh4kkwbowls3QsXEC9i5bargwdEOj+cy61/6589iWljemPP7dfe/L7PcUXAo0lP9T6EDz42dwubFyM/f392s9hxSRlNTmBJa+zVCF4S5cutRcdeHpwExk314NMEDEGY2OzB8svvPBCCoObD9cJOhG3J4EwqDomge6cxAmOD9ej6W22qxUNjDmGC2edQfXRMRrs7KHK5AkqH/uG6pVpatZrljj3UqFngLrmLZzxRcNqbZbKlOlKRwhbw2rL9MefUbNWtgV6cOhrZWp4vlixU8LzhbL9f7Y3WMieaYSPWQUGLDZt2jRj4UHQHnjggVmPlNgGbkidby4udBb89ddfT3fddddMu3GTbdiwQSlQEGpdu3Xv4/hlQdV1UjpRPHTo0Kz3woq0cHl4nX/ZXx4VHJub6LsJeFAeeughezBS7PONN97QPkFApOFbDvtkIhPWisa4hwqM+6jODQZuVW2OGplkTKTh8gCwpDuxWH5nL6Z27qaelZdRGhBWtBP4m4XPGYWWMpmGvQgyxSzl5rXWktZZOxiIue+++055DyKAC++6666btT4ebZMUaQiTSiBw8zz44IPK92677bZZ6+NGl49ToLvJVYKse7RXWer4vsqSDhIto9q/1/n/8MMPySRelrJJdwd+wwULFtjL5ZdfbnfE+P1vvvnmWb+HGCT2G8XjBFEvTqJY0brfQ/dUCjEOO4DrhjF3R+cPg0V4AJUwtoqJ7e+5fo5iSk6BBvkF/nzXcaKzhHRWgm402/RjtBc6y3XlypXK93Fjq24AtwEuXbSF6lh1VqNqXd3gVlhLGngJYpioiaj71HWkpsBvs3ateuLpsK4WufNsZ1+0wJhI5y13R1Dgl06DbxoWfT1EQk7x3C5qR2QxwUWLR9E04PaIC6FW4eZP9xvhobKMdeubiuxwAsF0Ow7TAg327vWeAi6O/TrRibRsEYeh3X3RAmMinbV8y8Xvn01BGfuvN6nVeFnROtJsSbuBx0j4z55//nl69913afv27aEeLaOgs0ZN+SEFKkta9Xjt5n+VhUrnpomKbmwBmA69A34E2KRfWoVbbHlUdFZ0WgwSvxid4zCMywMDiJNvfkStAvsOY0VDoLN96U3YdPOPwpJGAgVeTYtiVEy3R+WCkEXW69FaFnWVSEdxdQjchNh0OJxqe6pImqTD8Eyhs6Lh5oirU4gLoyLddeUlFAZY061we0CcZSs60+lvrsOOpT3EpAO3BAiVeMquDa/wQ9majEuksR/doKbpEEmVhXznnXfOErAkk1pMorOik35iNIFRkQ7r8gDHt+4IZdGGBfs6+q8v2KF3Tprjxz2/Cwu6uLSX0kDSA36mSOrGVz1RyOfM65Fe/lzV9iiRHc7tqixX06F3QOXquOCCC+xFblPc15jpa0FnRcPN0W5WNDAq0qDvuqsoDEI0kxBqxGcfe/rl0PvqWuY/BZ5Rk5RI+4nw8KrvIVvqKlEPa0nL+1IJsizcF198MUVF3ibOExbV4Gycg4c6S12X3u0HXfx9uw0YCoyLNCzpsNa0EOpqjCnj2Mfhf3k29D5gRRfO8ecSYdKBKvLCKQyyCMtFemRrUnaXRInsQFU/J7JfGvt1dgoQ0quuCmcICVRuFeGPPvPMM5Xrx4Uu9jvsk8np5IsWGBdpENaaBhDRI5aIjoeMuHADg4TYtqsFnXPPIIQVnemI5bQxMaG6OZ2DhbIIIY5cTlgQ66sGGaMMdso+UrngkmzF4pE96uCqyocv3ByqJ4K4Bg8hqE888YTys7BPJqrysSBtA+RBiCU8QVjTUQYDMaBX2rmbei3B7w45ICkoW+3A9ny1J6sX6TT5ooOCYkS6okBYcFO4lXlsZ1Q3vLAkVaKL9ZEZ57SYxblTPZq71RfxQtTJdooxrGmRcCRb1ojKiRpDrBJd0ZHhuNEm53EKl0QUoUNHKPYhyoxu3bpV6983nf0K6zpIKdQ0EVsM2eDaVbbVKg/MBQEW7wlrQBECC7HusIRfpJ97AXcGMhpNJsz0/Z13qnsawU3hFoMLcAN9l0RaWJNyxyVcFxAJp4Ut/lZ1dFEEBaIB61gW6Xvvvdf+WxZUrIu6F1HwCr/D37IbAt+RXTNBePTRR+3FD/fccw+ZRjyhmJigImliE2mIaf/PVtpRG1ERYg2cPm8h2BgIRGeA9bCgDGqUzkFF91/OSXVctBtRa/S2Oyr/prBGdYOGsrC7iXQU6wzfhfg5B7tEESJ5UA1tw5LPh78OdYk7zqgO/C2LNAQuikj7BdZuXEKKyRJYpCUQN206WaUVqeQdP+i3l9OZdg3l84OI8FBFdMiCJcRZFmnR0akELmpKOPYltw9RHvK+RKZcFJFWtR+Ws7OjUblv4s48BKjaGGcEhog3bzeXR+wjYLCmw0Z7pIHcUNG2opn2RhZS4W+WnzKEOMvWt4jwkH2o2K6Jm14V5SG7JUwUBVKF08ntb4VIw8LVVTM0iela1U7iEv9EwhTmrL8+VAGmVpDJ/7m+NQS6Xf3QTiAkKFEqlnbMunLDbUIDgSqTDsh1oYU4q+KrMcgoi7qpG1N+DJcL/IsBRjB37lwKiyrkbdmyZaf8j8FDmahJLbgG0X4sKveT6bh5WOWq30Y1P6Qp2lqkkYk49Mub2kaogRDo0yHcTtzgYmnXeFEdfm4O1eAhXArOCA4R5SKQrW9VkfwokR1y+5zHoZq92wSqaBb5GHQJQFGSWiCawkhQDQxi26aSZtB2DLyqnjyCzimZBhJTIAj1GfesS02RfzdQPOl0EWjmJCqR3rVr1yn/y6IsC5UqScJEOjiAMLr5tk0MeOlqgwA8UTgXlTVtKl5aFw0TZPtuhobwa+vOmS6WOq0kHq4AHzUEO45kFRN0XNJNnT9sn1jo080qjguVmD733HOn/C9b5LKw62KqTQG/tM7KM2FJ66r9+Q158yOifp5qVLHhAGGiUQcOnQX9cc5U+2m3AcSWmIqIeZ5nWdV+Y56TAB1H/98up84ftGch/6i0s9j7abvqEb5cPjVMUxZCP/HPUSM7nOgEX0R/RCWqJeynIp5f4VOF85mYfUZ2cejCBuMcQDRNy57nMXHtvJS4PxB9grZ0oy25Jp0OuN1MaS49GWfbvARVNWONGyJb0w9+1tOlfJvyR5uI0DA1g7jOFRG1I5F/M4i26QHEpA2aljpdbevVcn9874F/CjVhQFQgzhjQxJImqz4IugvGbTqouEptmiBOkfa6uVRRIm7fCWJF+xVzlSDL1uDQ0BAFxWv2Gb+Y8kuLxBwZr8zYoOC8t/sAYipGxiCQCNODWCYRU+0U53aO4XYj7YXaw/gDo05b5eY/liM7BG5CbCqyw4nsYlFNHBwmmUUn0MINpFpUv1FYkVZtS2VNxzHhbrsPIKYqz1mIp8hSLH/8ubH0bnQEKNTUYVnshTYKBfRCJ3a4KXUXp+nU5jDoxE+OW3biZ+JUN9xEWtcet04g6tOHatuw+pAiLjpZlWUdRqRVwof9v/LKK9rvoB2ykIW1xlXXF54QVL5hdAQmCyy1+wBiKotRQERRoAkgBRyijdfat3U5/ABRhuhjW3CltKs7wwuduOCxEQWT5AsQyRiqG1YVchUnEAi4F2S3DIoHoRORBcytYppf3NbV3ahuwm4yssPZDginOFZT/k9VEotX+3WT+EKoTRy7KAkrXwNxlEbVRc6gk0j7ZACxiHT92B5qThygZnXK/j875yLKzQk3Ci4KKjkHGEUhJQBLGwWWhAjjNYogZ3JFajYqM/+X9jep/FWTGuUmZTsy1HVuhjrmZygt4EaCUMsDOhC6NWvW0ObNm21xwo2AVGPdqHbYOFxsUxYAp+CLG12VRAOrUW4PRGDDhg0z8+1BtF5++WV68sknSUWQQTVVDQ+v7YSxvqMSZEDSL6oBP69zp7NmIXamOiiIp+yHxvZVHbUfdN+Rn1AEGED8Tok0RLk6vI1qB6TKd/swwes8Kpy/mvILVlBUogqxH078vkGjb9epMT072qPvxzma89McFVIyixYudNVNiAt9/fr1nt+PUr/XbYZrJ8g4E+U3BbrHXbT77rvvJj8ETXHHcaoGp3Sio7O+4xBSvwwMzL7w3ARNl8Tix5KWa0uL7ZkCHYXq90A2qMnSuWIAUY7qEAOIputXm8TowGHl49/MFuhvaU4focrup6i6bxulmkzOFugjr9aUAg3G/6dOI/9RtaxrSgW4mKP4Rzdu3Oi5TlT/q0okcGNEuREh/EGtLd36uvofuLlVn8VlRfuhVqsFWl8XNufnGFTWtkl3BJ7gVOfXb+cfdF8q0j6AaEykq3/cZrs5TK3XKqonsrYF7UXteJO++s9gN0tcQEhQEyGMkOJRr5UFl7D/MO2GwGzatImCohJpXWSHQOWvDxrZ0cpkId3EuX6eBFQWpsmytrpzj47FdISSGECUEQOIacWISDdLRwJZyGm2po+9VdFa0DKl/Q3bZ50GIAIQar++ZVgvcD8k5Y/TiZToYIJ0FKJYTxh3g+om9bIoVZ+nJa7cD6qoGL+dhi5jz6RQq/YB0TSVOOO1L5DmDEQjPulGQMu4kVJLujGRodLeSqDvQKjTEjeCG2/Lli22Pw/FgGAhOEfOIcywJrBAFIOIHLYt3CJymJzb3IkCN58fto0BTvgM0W5Yfs4bFO2GtSXaHcUqxXexDbRZtNFrAE0kQ4jvYBthBlrl/YaNs8Z30VGJ38HrGJz7EefO7ywr4nfHvvwIMzo0uLBECrnwa7t1auK8iHKofn5f7EecA7Gf3t5ez84TvyXuCefxiEgjv4hzJ6xvXdVAU2QajUZkU7A+8g6VP3kq0He6//rfKW0gYmT3Tf8Y6Dvf+/nf0/yf/wOlFVxIIha0XQrKMAwzw3DL4qQRCZIpdFPayBY7qVGZptMFFmeGaW9alxY+fYTSBmKuc8WOQN/JWaLOMAwTF2ZEOoRFXJ84QGkDIt09/xzf68Pq7l5yATEMw8SFEZFGokpQGuPpE2mknBd6B6g44F1lLJPL0+CSH1H+NE03ZxgmHZgR6a4QIp1CS7o6crIuSN+ipdQ5Vz8BLSzoAUugs5Zr5HQq1sQwTPowMnCYyXfb1nQzgJ8ZYXhpGzxE1T0AK7nXEuru+YupfGKUKmNHqVmv2e8Xegao64yF9t+oh53pCubDZhiGCYKx6I5s32KqBxwMrH25gwrnraY0MLVz96yyqLCYIchYVOQXshXNMEy8GIvuCFPlTlfnoxVMvvURBeV0nTCAYZj0YEyks4PBRbpZm6LaoXeo1Uxbbg6/daqddLBIMwwTM+ZE2nJ3wDcdlOrerTN1p1vF2LY3KShiUgGGYZg4MZrMkl+0KuhXbGu6lQWXxn/33swEAkEoLmGBZhgmfoyKdO57yygMtS922EvSQJwntr9HYcB8iQzDMHFjVKSzvYtD+aZBxXJ7JOmfhkAf/e0LFAZ2dTAMkxTGa3dgiqywYOaWJIRaCHQYNwfo+5uriGEYJgmMizRC8cJa0yDuKbbKn30ZSaBhRXexq4NhmISIpQpex6W3hor0EGCKreldD9szvpgCM4pjkHA0gkADtqIZhkkSI0X/VUBoTVjE9gzjZ64IVR8EQJyRTYhklSjiDBDRMfTLm4hhGCYhhmMTaYTWTf/+gUD1PHSgLkjWcqMUFq2y47E9920Jc+XgYSr/7+dUUqR7hwF1Oubdvc52dzAMwyREfCINUOmu/OHDtmCbwhZsS6gRSTL1xaA9aaxd7IgK1Dg8ZmcOwmI2IcxO+levpJ6VlxHDMEyCxCvSoPrFDjur0CSl/XX65uVpqp1onPI+akH3LbrQLiFqkp6fXkb9P1tJDMMwCTMc+/RZcFGEyUTUMf6HKo08MzVLoEF14gSNfrKTyqNfkylQL5oFmmGYVpHIHIfFpWspv2AFRaX8dcO2oL0Y/2Iv1UqTFBUI9NAveKCQYZjWkdhEtMVLbo0s1Edf9T+L9+TI5xQFIdBc1J9hmFZirOi/HyDUlO8OVacDA4TwRfsFro9GpRzKP929/BLbxcECzTBMq0lUpAFcH0h0CRpD3SgHH9+sV6YDizRHcTAMkyYSF2lgJ6gsXEHTCM+bNpdVKIPQPL8g/nnw5lVcOIlhmFTREpEGiHfu/Mmv7Sm0/FjV+YEs5QezVDveIL/ku3p8rYdUb1jP7N5gGCZtxB4n7QdY00gj96qAN/p2hY695S9JpTgwRP3nuhdCQpr34NpVnEXIMExaGU6FSAuEWNcP71JmKWLwcP9vJ+1XL+ZefKXWHw1x7rvuKnZtMAyTdtIl0gIINIS6YS31Y3tOEWxEeHz1Qkkr1PBD9y48nzrmzj/lfQgzJo5FmVG2nBmGaRPSKdIyEOoGxHriADVKR6hycJgOPT9Nla//HJIHce6wXBzd88+hwvwz7DhnMYMKxJn9zQzDtCHtIdIqULyp9Pm4/Xcml6N8/wDlenvYSmYY5nSifUWaYRjmO8AwQvCGiWEYhkkjw38CdZ7gTrHxjkYAAAAASUVORK5CYII=" />',
          opacity: 0.5
        },
        // //new page
        // snapshot.thermalPerformance.htc && snapshot.thermalPerformance.hlp && snapshot.thermalPerformance.epc ? { pageBreak: 'before',text: 'Current heating system', style: 'sectionHeading' } :'',
        {       // { text: 'Current heating system', style: 'sectionHeading', pageOrientation: 'landscape', pageBreak: 'before' },
          pageOrientation: 'landscape', pageBreak: 'after', style: 'sectionHeading', text: '' 
        },
        {style: 'sectionHeading', text: 'Current heating system' },

        // { style: 'sectionHeading', text: 'Current heating system' },
        imageURL ? { image: imageURL, width: 650 } : {},

        // {
        //   columns: [

        //     {
        //       layout: 'noBorders',
        //       fillColor: '#FFFFFF',
        //       table: {
        //         widths: [50, 170],
        //         body: [
        //           [{ text: 'Type:', style: 'tableHeader', background: '' }, { text: `${snapshot.heatingSystem.type}`, style: 'tableData', alignment: 'right' }],

        //         ]
        //       }
        //     },
        //     {
        //       //Radiators schematic image
        //     },

        //   ]
        // },
        // snapshot.thermalPerformance.htc && snapshot.thermalPerformance.hlp || snapshot.energyConsumption.peakDemand.length ?  { text: 'Footnotes', style: 'sectionHeading' } : '',
        // snapshot.thermalPerformance.htc && snapshot.thermalPerformance.hlp ?  { text: "¹ Thermal performance is determined by the SmartHTC algorithm, developed by our partners at Build Test Solutions. The SmartHTC algorithm uses smart meter data and an internal Temperature and Humidity Sensor (sold in our shop) to generate a home's building fabric score based on how well the home retains or loses heat.", style: 'paragraph' }:'',
        snapshot.energyConsumption.peakDemand.length ? { text: "² 'Coldest day' is determined by the average temperature of the coldest day of the heating season.", style: 'paragraph' } : '',


        {
          margin: [0, 5, 5, 30],
          height: 40,
          width: 120,
          image: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAWkAAABvCAYAAAAuVTHnAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAABrNSURBVHgB7Z1rrBVVlsfXed73Ay42goIPWnz1Y0SxnYRp1EkYJxOVTmQmgklnBiNIdzrG53zRaPPFOH4gnen4iE4mGSVxNBnUD9KY+DaxUXGmnUFktLmgXFTgAvd17nl3/Qv37WLfveu5q04dXL+kcu49p07VrjpV/71q7bXWzjQajSYxDMMwaWQ4SwzDMExqYZFmGIZJMSzSDMMwKYZFmmEYJsWwSDMMw6QYFmmGYZgUk6c2oVmdoub0EWqMH7Bfsdjvf/sKMp3zrCPqpmzXPMr0LqastWQK3RSWZqlMUzt3U3Xk8Mx7xSVnU/eVlxDDMEwSZNIcJ10/tocax60FrxDn2hQFBUKdnXMR5c5YRjnr1S+Tb31EE9vfo4Yl1DK5uf009Iub7FeGYZgYGU6dSEOY64d3Uf3QO6FE2Q1Y2hDs4nmrKWNZ2zrGf/eeLdBuZLs6aN7d61ioGYaJk/SINMS5tm+b/ZoEuQUrlGJdHx2jbzb/m69tFM46wxZqhmGYmBhuuU8avubq8DaqHdhBSQJLvWQtsljDivZL9eBhqnz2JRW/fzYxDMPEQUtFuma5Naq7nzLu1ggCxHrast4Li1dRftEqW3SDULMs7yIxDMPEQ0tEulXWsw5EiFT2bqXqF+9S/Xiv9U6BGIZh0kDiIt0sHaHpXQ+fEjqXFhrHDhBVytYI46WW07rH13fgw2YYhomLRJNZEEaXVoGeoTJOjdE3LBfMcWIYhmk1iYk0BLqcdoEW1CepOfo6CzXDMC0nEZGeEegWDhAGplFloWYYpuXELtLwQZf/8Ju2EehmzZFh+K1Qw7JmGIZpBbGLdJw+6Ey+284itGt2xIUl1PBRU7NKDMMwSRNrdEfl/7caFWiIMWpwoB5Hbu5Fs8S5MXHADu9DWnnTcrHUjxvKXrQs6cbYf1N2YDkxDMMkSWwibad5G4iDhrWMJBO7SJJHgSSINxDroYOojbxDNdQBidpZlPZRszBAme6lxDAMkxSxiXRl91MUBSHO+cWr7L9DbcOytAvnr7YXCHX1j9siiXVz4v8o03WetWFOdmEYJhliEemolitqQXf++FdGfc35BStsCxuZhXCHhAL+aUuos31/QQzDMEkQy8AhLNawwHru+smvYxkMxDY7fvQrKpy3WrtObtBjv5N7OdqDYZjEMC7SUaxouCWKS9dS3NguEI1Q1w+PeH3dsqZ3E8MwTBIYF+mwVjQsaDcL1zRuQu2JNYjIIXkMwySBUZFGREcYK1oM8CUN9pkd9D+llpMm3B4MwzAxY1akLVdHGDov/+fQERxR6bj01lD7bk6xSDMMEz/GLemgYGaUWDMGPcC+4WoJDFLGK4eJYRgmToyJtD2bdwhXR7EFbg6Z0LHYlW+IYRgmTsyJdIgUbKR4t9KKFojEmaCwJc0wTNwYS2Zxujoa002a3Fuj8tcNynZmqGtxjrrOyc3eueXqSAuwpiufvDjr/UYjT9VKkRr1HOXyVcoXapTN1k5+CEuaozwYhokRYyLdKJ10dRx7u0zHd1ZtoRYcw44GsjRvVQf1LD25S1ivsKTTAtqTtWt+7LP/L09320utMnua2WJXibp7xk+KdX2CGIZh4sKYu6M5cYBGnpmi0bcqpwi0oHaiQV89X6IT71dO7rhvMaWN/IK/sl9Lk300OTaoFGhQKXXR2LEhajSz7PJgGCZWjIg0Bg2PvjpNpf11z3WP7CjbbpDcvPRY0YLsnAupXs/bIu0F3B8TJ+baUR4MwzBxYUSkq0cnbReHXyDomRRa0mBifND3urC0a9UiMQzDxIURkYYrIwiwuJuZIUojzXou0PrVSgcxDMPEhZGBw9roGAVF5bdmzDE+Pk7vv/++/Qr6+vpo4cKFdNFF4dLgkwLtfe2112b+b5d2M0xcxDp9VjuS68hRfdrbt55WDh48SM8++yy9+OKLMwLtBKJ37bXX0saNG+mss87yu1lb8B9//PFZ769bt87eXlTQ1kceecRutwq0e/ny5XTNNdfQjTfeSH644447Zp0DCP7mzZuV66NzeP3112lkZGRmn1u2bFGuqzsf2Db2IfPpp5/ax+cE5//qq68OdP5wPI899hhNTEzYv7XAra1eqM7TFVdcQbfffjsFBb/fSy+9pP1cnBu8ig4Yvyv+NrEft+sRvyt+M+d5A7gX0AaZ9evXkwmi3iNGRLrr4iWB1s8WOymTS2f/kO203B0nqC3BhQshUImzAJ9hPSwQO79ijQv8gw8+mPX+DTfcQFGBON5///2e7cZ6WCBSTz/9tGe7cTNCHJ2oBFSAm95pxYv9qgQE5wJC7USIjq798vnD/9hfkBsY+0QnLON2XG7g/KBjksHvHUak8T35vHiB84ZrEfvzK9a66/GWW27RfgfXjSzsopNQEfQ4dES9R4z4pHOW6BZ6B3yv3zlnPlX3fUVpo1mqULGzFug7HZ1TlAb8CJ0MhBpWVCvBjaCy5NzADQorx+s7KheJsJJVyBaW2/qq98O4ZIRbyi8qQY2CSugAji/IbxIF7OeZZ56hNWvWKH+DIPT29irfx/GoLO8wHVHSmBHpuf3Us3AJZX1Yx/muHuqev5hqB9MXX1y12lQsTFBhoNPX+l1IaMm13jWCCxsCHQZYUrAwWkXYduOm8/quzrpUCSyEQra6wZ49e3xvI+gjuyCI8OpENSxuHYTpfXnht/MNg+oax/Vh4kkwbowls3QsXEC9i5bargwdEOj+cy61/6589iWljemPP7dfe/L7PcUXAo0lP9T6EDz42dwubFyM/f392s9hxSRlNTmBJa+zVCF4S5cutRcdeHpwExk314NMEDEGY2OzB8svvPBCCoObD9cJOhG3J4EwqDomge6cxAmOD9ej6W22qxUNjDmGC2edQfXRMRrs7KHK5AkqH/uG6pVpatZrljj3UqFngLrmLZzxRcNqbZbKlOlKRwhbw2rL9MefUbNWtgV6cOhrZWp4vlixU8LzhbL9f7Y3WMieaYSPWQUGLDZt2jRj4UHQHnjggVmPlNgGbkidby4udBb89ddfT3fddddMu3GTbdiwQSlQEGpdu3Xv4/hlQdV1UjpRPHTo0Kz3woq0cHl4nX/ZXx4VHJub6LsJeFAeeughezBS7PONN97QPkFApOFbDvtkIhPWisa4hwqM+6jODQZuVW2OGplkTKTh8gCwpDuxWH5nL6Z27qaelZdRGhBWtBP4m4XPGYWWMpmGvQgyxSzl5rXWktZZOxiIue+++055DyKAC++6666btT4ebZMUaQiTSiBw8zz44IPK92677bZZ6+NGl49ToLvJVYKse7RXWer4vsqSDhIto9q/1/n/8MMPySRelrJJdwd+wwULFtjL5ZdfbnfE+P1vvvnmWb+HGCT2G8XjBFEvTqJY0brfQ/dUCjEOO4DrhjF3R+cPg0V4AJUwtoqJ7e+5fo5iSk6BBvkF/nzXcaKzhHRWgm402/RjtBc6y3XlypXK93Fjq24AtwEuXbSF6lh1VqNqXd3gVlhLGngJYpioiaj71HWkpsBvs3ateuLpsK4WufNsZ1+0wJhI5y13R1Dgl06DbxoWfT1EQk7x3C5qR2QxwUWLR9E04PaIC6FW4eZP9xvhobKMdeubiuxwAsF0Ow7TAg327vWeAi6O/TrRibRsEYeh3X3RAmMinbV8y8Xvn01BGfuvN6nVeFnROtJsSbuBx0j4z55//nl69913afv27aEeLaOgs0ZN+SEFKkta9Xjt5n+VhUrnpomKbmwBmA69A34E2KRfWoVbbHlUdFZ0WgwSvxid4zCMywMDiJNvfkStAvsOY0VDoLN96U3YdPOPwpJGAgVeTYtiVEy3R+WCkEXW69FaFnWVSEdxdQjchNh0OJxqe6pImqTD8Eyhs6Lh5oirU4gLoyLddeUlFAZY061we0CcZSs60+lvrsOOpT3EpAO3BAiVeMquDa/wQ9majEuksR/doKbpEEmVhXznnXfOErAkk1pMorOik35iNIFRkQ7r8gDHt+4IZdGGBfs6+q8v2KF3Tprjxz2/Cwu6uLSX0kDSA36mSOrGVz1RyOfM65Fe/lzV9iiRHc7tqixX06F3QOXquOCCC+xFblPc15jpa0FnRcPN0W5WNDAq0qDvuqsoDEI0kxBqxGcfe/rl0PvqWuY/BZ5Rk5RI+4nw8KrvIVvqKlEPa0nL+1IJsizcF198MUVF3ibOExbV4Gycg4c6S12X3u0HXfx9uw0YCoyLNCzpsNa0EOpqjCnj2Mfhf3k29D5gRRfO8ecSYdKBKvLCKQyyCMtFemRrUnaXRInsQFU/J7JfGvt1dgoQ0quuCmcICVRuFeGPPvPMM5Xrx4Uu9jvsk8np5IsWGBdpENaaBhDRI5aIjoeMuHADg4TYtqsFnXPPIIQVnemI5bQxMaG6OZ2DhbIIIY5cTlgQ66sGGaMMdso+UrngkmzF4pE96uCqyocv3ByqJ4K4Bg8hqE888YTys7BPJqrysSBtA+RBiCU8QVjTUQYDMaBX2rmbei3B7w45ICkoW+3A9ny1J6sX6TT5ooOCYkS6okBYcFO4lXlsZ1Q3vLAkVaKL9ZEZ57SYxblTPZq71RfxQtTJdooxrGmRcCRb1ojKiRpDrBJd0ZHhuNEm53EKl0QUoUNHKPYhyoxu3bpV6983nf0K6zpIKdQ0EVsM2eDaVbbVKg/MBQEW7wlrQBECC7HusIRfpJ97AXcGMhpNJsz0/Z13qnsawU3hFoMLcAN9l0RaWJNyxyVcFxAJp4Ut/lZ1dFEEBaIB61gW6Xvvvdf+WxZUrIu6F1HwCr/D37IbAt+RXTNBePTRR+3FD/fccw+ZRjyhmJigImliE2mIaf/PVtpRG1ERYg2cPm8h2BgIRGeA9bCgDGqUzkFF91/OSXVctBtRa/S2Oyr/prBGdYOGsrC7iXQU6wzfhfg5B7tEESJ5UA1tw5LPh78OdYk7zqgO/C2LNAQuikj7BdZuXEKKyRJYpCUQN206WaUVqeQdP+i3l9OZdg3l84OI8FBFdMiCJcRZFmnR0akELmpKOPYltw9RHvK+RKZcFJFWtR+Ws7OjUblv4s48BKjaGGcEhog3bzeXR+wjYLCmw0Z7pIHcUNG2opn2RhZS4W+WnzKEOMvWt4jwkH2o2K6Jm14V5SG7JUwUBVKF08ntb4VIw8LVVTM0iela1U7iEv9EwhTmrL8+VAGmVpDJ/7m+NQS6Xf3QTiAkKFEqlnbMunLDbUIDgSqTDsh1oYU4q+KrMcgoi7qpG1N+DJcL/IsBRjB37lwKiyrkbdmyZaf8j8FDmahJLbgG0X4sKveT6bh5WOWq30Y1P6Qp2lqkkYk49Mub2kaogRDo0yHcTtzgYmnXeFEdfm4O1eAhXArOCA4R5SKQrW9VkfwokR1y+5zHoZq92wSqaBb5GHQJQFGSWiCawkhQDQxi26aSZtB2DLyqnjyCzimZBhJTIAj1GfesS02RfzdQPOl0EWjmJCqR3rVr1yn/y6IsC5UqScJEOjiAMLr5tk0MeOlqgwA8UTgXlTVtKl5aFw0TZPtuhobwa+vOmS6WOq0kHq4AHzUEO45kFRN0XNJNnT9sn1jo080qjguVmD733HOn/C9b5LKw62KqTQG/tM7KM2FJ66r9+Q158yOifp5qVLHhAGGiUQcOnQX9cc5U+2m3AcSWmIqIeZ5nWdV+Y56TAB1H/98up84ftGch/6i0s9j7abvqEb5cPjVMUxZCP/HPUSM7nOgEX0R/RCWqJeynIp5f4VOF85mYfUZ2cejCBuMcQDRNy57nMXHtvJS4PxB9grZ0oy25Jp0OuN1MaS49GWfbvARVNWONGyJb0w9+1tOlfJvyR5uI0DA1g7jOFRG1I5F/M4i26QHEpA2aljpdbevVcn9874F/CjVhQFQgzhjQxJImqz4IugvGbTqouEptmiBOkfa6uVRRIm7fCWJF+xVzlSDL1uDQ0BAFxWv2Gb+Y8kuLxBwZr8zYoOC8t/sAYipGxiCQCNODWCYRU+0U53aO4XYj7YXaw/gDo05b5eY/liM7BG5CbCqyw4nsYlFNHBwmmUUn0MINpFpUv1FYkVZtS2VNxzHhbrsPIKYqz1mIp8hSLH/8ubH0bnQEKNTUYVnshTYKBfRCJ3a4KXUXp+nU5jDoxE+OW3biZ+JUN9xEWtcet04g6tOHatuw+pAiLjpZlWUdRqRVwof9v/LKK9rvoB2ykIW1xlXXF54QVL5hdAQmCyy1+wBiKotRQERRoAkgBRyijdfat3U5/ABRhuhjW3CltKs7wwuduOCxEQWT5AsQyRiqG1YVchUnEAi4F2S3DIoHoRORBcytYppf3NbV3ahuwm4yssPZDginOFZT/k9VEotX+3WT+EKoTRy7KAkrXwNxlEbVRc6gk0j7ZACxiHT92B5qThygZnXK/j875yLKzQk3Ci4KKjkHGEUhJQBLGwWWhAjjNYogZ3JFajYqM/+X9jep/FWTGuUmZTsy1HVuhjrmZygt4EaCUMsDOhC6NWvW0ObNm21xwo2AVGPdqHbYOFxsUxYAp+CLG12VRAOrUW4PRGDDhg0z8+1BtF5++WV68sknSUWQQTVVDQ+v7YSxvqMSZEDSL6oBP69zp7NmIXamOiiIp+yHxvZVHbUfdN+Rn1AEGED8Tok0RLk6vI1qB6TKd/swwes8Kpy/mvILVlBUogqxH078vkGjb9epMT072qPvxzma89McFVIyixYudNVNiAt9/fr1nt+PUr/XbYZrJ8g4E+U3BbrHXbT77rvvJj8ETXHHcaoGp3Sio7O+4xBSvwwMzL7w3ARNl8Tix5KWa0uL7ZkCHYXq90A2qMnSuWIAUY7qEAOIputXm8TowGHl49/MFuhvaU4focrup6i6bxulmkzOFugjr9aUAg3G/6dOI/9RtaxrSgW4mKP4Rzdu3Oi5TlT/q0okcGNEuREh/EGtLd36uvofuLlVn8VlRfuhVqsFWl8XNufnGFTWtkl3BJ7gVOfXb+cfdF8q0j6AaEykq3/cZrs5TK3XKqonsrYF7UXteJO++s9gN0tcQEhQEyGMkOJRr5UFl7D/MO2GwGzatImCohJpXWSHQOWvDxrZ0cpkId3EuX6eBFQWpsmytrpzj47FdISSGECUEQOIacWISDdLRwJZyGm2po+9VdFa0DKl/Q3bZ50GIAIQar++ZVgvcD8k5Y/TiZToYIJ0FKJYTxh3g+om9bIoVZ+nJa7cD6qoGL+dhi5jz6RQq/YB0TSVOOO1L5DmDEQjPulGQMu4kVJLujGRodLeSqDvQKjTEjeCG2/Lli22Pw/FgGAhOEfOIcywJrBAFIOIHLYt3CJymJzb3IkCN58fto0BTvgM0W5Yfs4bFO2GtSXaHcUqxXexDbRZtNFrAE0kQ4jvYBthBlrl/YaNs8Z30VGJ38HrGJz7EefO7ywr4nfHvvwIMzo0uLBECrnwa7t1auK8iHKofn5f7EecA7Gf3t5ez84TvyXuCefxiEgjv4hzJ6xvXdVAU2QajUZkU7A+8g6VP3kq0He6//rfKW0gYmT3Tf8Y6Dvf+/nf0/yf/wOlFVxIIha0XQrKMAwzw3DL4qQRCZIpdFPayBY7qVGZptMFFmeGaW9alxY+fYTSBmKuc8WOQN/JWaLOMAwTF2ZEOoRFXJ84QGkDIt09/xzf68Pq7l5yATEMw8SFEZFGokpQGuPpE2mknBd6B6g44F1lLJPL0+CSH1H+NE03ZxgmHZgR6a4QIp1CS7o6crIuSN+ipdQ5Vz8BLSzoAUugs5Zr5HQq1sQwTPowMnCYyXfb1nQzgJ8ZYXhpGzxE1T0AK7nXEuru+YupfGKUKmNHqVmv2e8Xegao64yF9t+oh53pCubDZhiGCYKx6I5s32KqBxwMrH25gwrnraY0MLVz96yyqLCYIchYVOQXshXNMEy8GIvuCFPlTlfnoxVMvvURBeV0nTCAYZj0YEyks4PBRbpZm6LaoXeo1Uxbbg6/daqddLBIMwwTM+ZE2nJ3wDcdlOrerTN1p1vF2LY3KShiUgGGYZg4MZrMkl+0KuhXbGu6lQWXxn/33swEAkEoLmGBZhgmfoyKdO57yygMtS922EvSQJwntr9HYcB8iQzDMHFjVKSzvYtD+aZBxXJ7JOmfhkAf/e0LFAZ2dTAMkxTGa3dgiqywYOaWJIRaCHQYNwfo+5uriGEYJgmMizRC8cJa0yDuKbbKn30ZSaBhRXexq4NhmISIpQpex6W3hor0EGCKreldD9szvpgCM4pjkHA0gkADtqIZhkkSI0X/VUBoTVjE9gzjZ64IVR8EQJyRTYhklSjiDBDRMfTLm4hhGCYhhmMTaYTWTf/+gUD1PHSgLkjWcqMUFq2y47E9920Jc+XgYSr/7+dUUqR7hwF1Oubdvc52dzAMwyREfCINUOmu/OHDtmCbwhZsS6gRSTL1xaA9aaxd7IgK1Dg8ZmcOwmI2IcxO+levpJ6VlxHDMEyCxCvSoPrFDjur0CSl/XX65uVpqp1onPI+akH3LbrQLiFqkp6fXkb9P1tJDMMwCTMc+/RZcFGEyUTUMf6HKo08MzVLoEF14gSNfrKTyqNfkylQL5oFmmGYVpHIHIfFpWspv2AFRaX8dcO2oL0Y/2Iv1UqTFBUI9NAveKCQYZjWkdhEtMVLbo0s1Edf9T+L9+TI5xQFIdBc1J9hmFZirOi/HyDUlO8OVacDA4TwRfsFro9GpRzKP929/BLbxcECzTBMq0lUpAFcH0h0CRpD3SgHH9+sV6YDizRHcTAMkyYSF2lgJ6gsXEHTCM+bNpdVKIPQPL8g/nnw5lVcOIlhmFTREpEGiHfu/Mmv7Sm0/FjV+YEs5QezVDveIL/ku3p8rYdUb1jP7N5gGCZtxB4n7QdY00gj96qAN/p2hY695S9JpTgwRP3nuhdCQpr34NpVnEXIMExaGU6FSAuEWNcP71JmKWLwcP9vJ+1XL+ZefKXWHw1x7rvuKnZtMAyTdtIl0gIINIS6YS31Y3tOEWxEeHz1Qkkr1PBD9y48nzrmzj/lfQgzJo5FmVG2nBmGaRPSKdIyEOoGxHriADVKR6hycJgOPT9Nla//HJIHce6wXBzd88+hwvwz7DhnMYMKxJn9zQzDtCHtIdIqULyp9Pm4/Xcml6N8/wDlenvYSmYY5nSifUWaYRjmO8AwQvCGiWEYhkkjw38CdZ7gTrHxjkYAAAAASUVORK5CYII=" />',
          opacity: 0.5


        },


      ],

      styles: {
        sectionHeading: {
          fontSize: 16,
          color: '#102E7C',
          margin: [0, 20, 0, 20],
          bold: true,
        },
        heading6: {
          fontSize: 16,
          margin: [0, 15, 0, 10]
        },
        text: {
          margin: [0, 2, 0, 2]
        },

        table: {
          fontSize: 12,
          bold: false,
          margin: [3, 0, 3, 3],
          color: 'black'
        },
        tablepad: {
          fontSize: 10,
          bold: false,
          margin: [3, 20, 3, 0],
          color: 'black'
        },
        tableHeader: {
          fontSize: 12,
          bold: true,
          margin: [10, 5, 10, 0],
          color: 'black',

        },
        tableData: {
          fontSize: 12,
          bold: false,
          margin: [5, 5, 5, 5],
          color: 'black'
        },
        paragraph: {
          fontsize: 12,
          margin: [5, 10, 5, 5]
        }


      }
    }
    return dd
  }

}
